import { useGoogleTranslate } from "../hook/useGoogleTranslate";

const TranslateWidget = () => {
  useGoogleTranslate();

  return (
    <div
      id="google_translate_element"
      style={{
        padding: "8px 8px",
        borderRadius: "6px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        minHeight: "40px",
      }}
    />
  );
};

export default TranslateWidget;
